import { Injectable } from '@angular/core';
import { API_ENDPOINT } from '@core/configs';
import { DeleteSupportStaffDTO, EditSupportStaffDTO, InviteSupportStaffDTO } from '@core/models/dto/user-role.dto';
import { ApiService } from '../common/api.service';

@Injectable({
  providedIn: 'root',
})
export class UserRoleService {
  constructor(private readonly http: ApiService) {
  }

  getAllUserByRole() {
    return this.http.get(
      API_ENDPOINT.userRole.controller + API_ENDPOINT.userRole.getUserByRole,
    );
  }

  getCompanyRoleByUser(userId) {
    return this.http.get(
      API_ENDPOINT.userRole.controller + API_ENDPOINT.userRole.getCompanyRoleByUser + userId,
    );
  }

  getUserIdByEmail(email) {
    return this.http.post(
      API_ENDPOINT.userRole.controller + API_ENDPOINT.userRole.getUserIdByEmail,
      email,
    );
  }

  getSupportStaff(companyId) {
    return this.http.get(
      API_ENDPOINT.userRole.controller + API_ENDPOINT.userRole.getSupportStaff + companyId,
    );
  }

  inviteSupportStaff(newSupportStaff: InviteSupportStaffDTO) {
    return this.http.post(
      API_ENDPOINT.userRole.controller + API_ENDPOINT.userRole.inviteSupportStaff,
      newSupportStaff,
    );
  }

  editSupportStaff(editSupportStaff: EditSupportStaffDTO) {
    return this.http.put(
      API_ENDPOINT.userRole.controller + API_ENDPOINT.userRole.editSupportStaff,
      editSupportStaff,
    );
  }

  deleteSupportStaff(deleteSupportStaff: DeleteSupportStaffDTO) {
    return this.http.put(
      API_ENDPOINT.userRole.controller + API_ENDPOINT.userRole.deleteSupportStaff,
      deleteSupportStaff,
    );
  }

  deleteAccount(userId: number) {
    return this.http.delete(
      API_ENDPOINT.userRole.controller + API_ENDPOINT.userRole.deleteAccount + userId
    )
  }
}
